import styled from 'styled-components'

export const Heading2 = styled.h2`
  color: rgb(20, 23, 26);
  margin: 0;
`
